export const SortConfig = {
  defaultFilterValue: 1,
  filterLabel: 'Sort by',
  filterOptionsForResult: [
    {
      name: 'Relevance',
      Value: 'Rank',
      Direction: 1,
      SortType: 1,
      id:1
    },
    {
      name: 'Newest first',
      Value: 'sortDate',
      Direction: 1,
      SortType: 0,
      id:2
    },
    {
      name: 'Oldest first',
      Value: 'sortDate',
      Direction: 0,
      SortType: 0,
      id:3
    }
  ],
  filterOptionsForBrowse: [
    {
      name: 'Relevance',
      Value: 'Rank',
      Direction: 1,
      SortType: 1,
      id:1
    },
    {
      name: 'Newest first',
      Value: 'sortDate',
      Direction: 1,
      SortType: 0,
      id:2
    },
    {
      name: 'Oldest first',
      Value: 'sortDate',
      Direction: 0,
      SortType: 0,
      id:3
    },
    {
      name: 'Title: A to Z',
      Value: 'ESC_TITLE.keyword',
      Direction: 0,
      SortType: 2,
      id:4
    },
    {
      name: 'Title: Z to A',
      Value: 'ESC_TITLE.keyword',
      Direction: 1,
      SortType: 2,
      id:5
    }
  ]
};

export const PeopleSortConfig = {
  defaultFilterValue: 1,
  filterLabel: 'Sort by',
  filterOptions: [
    {
      name: 'Relevance',
      Value: 'Rank',
      Direction: 1,
      SortType: 1,
      id:1
    },
    {
      name: 'First Name (A-Z)',
      Value: 'ESC_FIRSTNAME.keyword',
      Direction: 0,
      SortType: 0,
      id:2
    },
    {
      name: 'First Name (Z-A)',
      Value: 'ESC_FIRSTNAME.keyword',
      Direction: 1,
      SortType: 0,
      id:3
    },
    {
      name: 'Last Name (A-Z)',
      Value: 'ESC_LASTNAME.keyword',
      Direction: 0,
      SortType: 0,
      id:4
    },
    {
      name: 'Last Name (Z-A)',
      Value: 'ESC_LASTNAME.keyword',
      Direction: 1,
      SortType: 0,
      id:5
    }
  ]
};